export default "/images/vendor/flag-icon-css/flags/1x1/bi.svg?5adb744e68bc13f75956296eb29398a7";